exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".smallSymbol{position:relative;width:18px;height:18px}.rubyCrystal{position:absolute;width:45%;height:45%;left:50%;top:50%;background-color:#e2e3e4;border-radius:2px;transform:translate(-50%, -50%) rotate(45deg)}", ""]);
